import React, { useEffect, useState } from "react";
import { Input, Modal, VbButton } from "@/components/vb";

interface CreateWorkspaceDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCreate: (name: string) => Promise<void> | void;
  loading?: boolean;
}

const CreateWorkspaceDialog: React.FC<CreateWorkspaceDialogProps> = ({
  open,
  onOpenChange,
  onCreate,
  loading = false,
}) => {
  const [name, setName] = useState("");

  useEffect(() => {
    if (!open) {
      setName("");
    }
  }, [open]);

  const handleCreate = async () => {
    const trimmedName = name.trim();
    if (!trimmedName) {
      return;
    }

    await onCreate(trimmedName);
  };

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title="Name your workspace"
      description="Create a new workspace to organize companies and reports."
      widthClassName="max-w-md"
      footer={
        <>
          <VbButton type="button" variant="secondary" onClick={() => onOpenChange(false)}>
            Cancel
          </VbButton>
          <VbButton
            type="button"
            variant="primary"
            onClick={handleCreate}
            disabled={loading || !name.trim()}
          >
            {loading ? "Creating..." : "Create"}
          </VbButton>
        </>
      }
    >
      {/* 255 = Workspace.name, same as the rename box in settings. It was 120
          here, so a name you could rename to was one you couldn't create. */}
      <Input
        value={name}
        onChange={(event) => setName(event.target.value)}
        placeholder="Workspace name"
        maxLength={255}
        autoFocus
      />
    </Modal>
  );
};

export default CreateWorkspaceDialog;
